<template>
	<div>
		<el-carousel height="600px" :interval="5000">
		    <el-carousel-item class="slider-item" v-for="(item,index) in sliders" :key="index">
				<el-image :src="item.img" class="slider_img" fit="cover"></el-image>
		    </el-carousel-item>
		</el-carousel>

		<!-- 业务涵盖 -->
		<div id="Service">
		    <div class="container" style="text-align: center;">
		        <h3 style="color:#2b2a2a;font-size: 30px;font-weight: normal;">业务涵盖</h3>
		        <p style="color:#b2b2b2">The Best Service You Never See</p>
		    </div>
		    <div class="container">
		        <el-row class="Service-container" :gutter="20">
					<el-col :span="6" class="Service-item wow slideInUp"
						v-for="(item,index) in serviceList" :key="index" @click.native="ServiceClick(item)">
						<div class="Service-item-wrapper">
							<div class="Service-item-top">
								<h4>{{item.title}}</h4>
								<i></i>
								<p>{{item.eng_title}}</p>
							</div>
							<div class="Service-item-img">
								<img :src="item.img" alt="服务">
							</div>
							<div class="Service-item-border"></div>
						</div>
					</el-col>
		        </el-row>
		    </div>
		</div>

		<!-- 经典案例 -->
		<div class="case-box">
			<div class="container" style="text-align: center;">
			  <h3 style="color:#fff;font-size: 30px;font-weight: normal;padding-top: 50px;">经典案例</h3>
			  <p style="color:#fff">Classic Case</p>
			</div>
			<ul class="case-item">
			  <li
				v-for="(item,index) in caseList"
				:key="index"
				v-lazy:background-image="item.url"
			  >
				<router-link
				  class="text-decoration"
				  :to="{ name: item.path}"
				>
				  <div class="case-item-hover">
					<p class="classname">{{item.classname}}</p>
					<p class="hover-title">{{item.title}}</p>
					<div class="bottom"></div>
					<div class="more">
					  <span>MORE</span>
					</div>
				  </div>
				</router-link>
			  </li>
			</ul>
		</div>

		<!-- 公司简介 -->
		<div class="company">
			<el-row>
				<el-col :span="14">
					<div class="company-text">
						<h5>公司介绍<span>About Company</span></h5>
						<p>通慧科技集团（证券代码：872345）成立于2005年6月，是一家专注于工程质量安全管控及智慧工程感知软硬件产品，集研发、设计、施工、生产于一体的综合服务商。公司先后荣获多项重要荣誉，包括国家高新技术企业、国家专精特新“小巨人”企业、江西省专业化“小巨人”企业、江西省“专精特新”中小企业、省大数据示范企业、省产教融合示范企业、省级企业实践培训基地、省“重点数字经济产品”推荐企业以及科技“小巨人”领军企业等称号。2022年，“通慧科技TOHUI SCIENCE&TECHNOLOGY”品牌被江西省工业强省建设工作领导小组办公室、省市场监督管理局、省工信厅认定为“赣出精品”商标。此外，公司还获批设立了市级工程技术中心和省级企业技术中心，并在2025年获批设立“博士科研创新中心”...</p>
						<!-- <router-link :to="{ name: 'goin'}">
							<el-button style="margin-top: 20px;" type="primary" size="medium">查看更多</el-button>
						</router-link> -->
						<div class="read_more" style="text-align:left;">
							<router-link :to="{ name: 'goin'}">	查看更多</router-link>
						</div>
					</div>
				</el-col>
				<el-col :span="10">
					<img style="width: 100%;" src="../assets/img/jianjietopmin.png" />
				</el-col>
			</el-row>
		</div>

		<!-- 新闻资讯 -->
		<div id="NewsInformation">
		    <div class="container">
		        <div class="container" style="text-align: center;">
		            <h3 style="color:#2b2a2a;font-size: 30px;font-weight: normal;">新闻资讯</h3>
		            <p style="color:#b2b2b2">Company News</p>
		        </div>
				<div class="nav container" style="text-align: center;">
				    <a v-for="(type,index) in newstypeList" href="javascript:;"
					@click="newstypeChange(type)"
					:class="{'active':type.id == newstype}">{{ type.name }}</a>
				</div>
		        <ul class="content-nav-item container-fuild">
		            <!-- <li v-for="(item,index) in newsList" :key="index"
					style="visibility: visible;"
					class="wow fadeIn" @click="toNewDetail(item)">

		                <div class="content">
		                    <h5>{{ limitLength(item.title,20) }}</h5>
		                    <p>{{ limitLength(item.remark,40) }}</p>
		                </div>
		                <div class="time">
		                    <p>{{ item.createTime.substr(5,5) }}</p>
		                    <span>{{ item.createTime.substr(0,4) }}</span>
		                </div>
		                <div class="circle">
		                    <img src="../assets/img/circle.png">
		                    <i class="line center-block"></i>
		                </div>
		            </li> -->
					<li class="item-list" v-for="(item,index) in newsList" :key="index" style="visibility: visible;"  @click="toNewDetail(item)" >
						<div class="item-img" v-lazy:background-image="item.cover"></div>
						<p class="item-list-title">{{limitLength(item.title)}}</p>
						<p class="item-list-content">{{item.remark}}</p>
						<div class="item-list-more">
							<img src="../assets/img/sanjiao.png" />
							<span>查看详情</span>
						</div>
					</li>



		        </ul>
				<div class="read_more" style="text-align: center;">
					<router-link :to="{ name: 'news'}">
						查看更多
					</router-link>
				</div>
				<!-- <div class="contaianer-fuild more" style="text-align: center;margin-bottom: 40px;">
					<router-link :to="{ name: 'news'}">
						<i class="glyphicon el-icon-menu" style="color: #666;"></i>
					</router-link>
				</div> -->
		    </div>
		</div>
	</div>
</template>

<script>
import { WOW } from 'wowjs';
export default {
	name: 'Index',
	data() {
		return {
			sliders: [
				{img: require('../assets/img/banner01.jpg')},
				{img: require('../assets/img/banner02.jpg')},
				{img: require('../assets/img/banner03.jpg')},
			],
			serviceList: [
			    {
			        id: '',
			        title: '软件开发',
			        eng_title: 'Software development',
			        img: require('@/assets/img/service1.jpg'),
					router:'',
					name:''
			    },{
			        id: '58e39bb2-8d1c-4e2c-8477-89986f74cf50',
			        title: '智慧交通',
			        eng_title: 'Intelligent transportation',
			        img: require('@/assets/img/service2.jpg'),
					router:'traffic',
					name:'智慧治超'
			    },{
			        id: 'c26fab28-881a-4e2a-835b-ab2c5fc01471',
			        title: '智慧工地',
			        eng_title: 'Smart construction site',
			        img: require('@/assets/img/service3.jpg'),
					router:'saas',
					name:'项目管理'
			    },{
			        id: 'd908d3c2-3ea5-4b57-8a68-f108a5c12472',
			        title: '结构物健康监测',
			        eng_title: 'Health monitoring of structures',
			        img: require('@/assets/img/service4.jpg'),
					router:'product',
					name:'桥梁'
			    }
			],
			caseList: [{
				classname:'智慧交通',
				title:'井冈山G356龙市至睦村、S541龙市至茨坪段“畅、安、舒、美”科技示范路工程',
				url:'https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDAYWeAe9vyABbQ2id7cZw247.png',
				path:'case01'
			},{
				classname:'智慧工地',
				title:'江西港口集团项目',
				url:'https://file.jxth.com.cn/group1/M01/00/19/dSm0ymCWLR2AVHzEAAnRuO95c_I137.jpg',
				path:'case02'
			},{
				classname:'结构物健康监测',
				title:'江西省信江航电枢纽项目',
				url:'https://file.jxth.com.cn/group1/M00/00/19/dSm0ymCWKfiADY4ZAAQhxZVT6ZI133.jpg',
				path:'case'
			}],
			newsList:[],
			newstypeList: [],
			pageInfo: {
			  curPage: 1,
			  pageSize: 3,
			  total: 0
			},
			newstype: '',
		}
	},
	methods:{
		ServiceClick(item){
			if(item.id){
				this.$router.push({
					name: item.router,
					params: {
						id: item.id,
						name: item.name
					}
				})
			}
		},
		toNewDetail(item){
			this.$router.push({
				name: 'newsdetails',
				params: {
					id: item.id,
				}
			})
		},
		limitLength(data,len){
			if (!data) {
				return ''
			}
				if(data.length>len){
					return data.slice(0,len)+"..."
				}else{
					return data
				}
		},
		async initPage(){
			await this.getAllList()
			await this.getListByPage()
		},
		async getAllList(){
			// await this.$http.post('/oa/newcms/category/getChildById',{parentId:"a1fbc39c-1969-4e0d-bca1-4304d3b0e52e"})
			// .then(response => {
			// 	this.newstypeList = response.data.result
			// 	this.newstype = this.newstypeList[0].id
			// 	// console.log(response)
			// })
			// .catch(error=> {

			// })
			const {data : { result }} = await this.$http({
				method: 'post',
				url: this.$baseURL + '/base/dict/getDataList',
				data: {
					dictCode: 'articleType'
				}
			})
			const newstypeList = result[0].children
			this.newstypeList = newstypeList.map(item => {
				return {
					id: item.id,
					name: item.dictName
				}
			})
			!this.newstype ? this.newstype = this.newstypeList[0].id : ''
		},
		async getListByPage(){
			var curPage = this.pageInfo.curPage
			var pageSize = this.pageInfo.pageSize
			var category = this.newstype
			/* 获取新闻资讯 */
			// this.$http.post('/oa/newcms/article/getListByPage',{curPage,pageSize,category})
			// .then(response => {
			// 	this.newsList = response.data.result.data
			// 	this.pageInfo.total = Number(response.data.result.total)
			// 	// console.log(this.newsList)
			// })
			// .catch(error=> {

			// })
			const {data : { result }} = await this.$http({
				method: 'post',
				url: this.$baseURL + '/oa/newcmsArticle/getDataListByPage',
				data: {
					curPage,
					pageSize,
					category
				}
			})
			this.pageInfo.total = Number(result.total)
			this.newsList = result.records.map(item => {
				return {
					id: item.id,
					cover: item.cover,
					title: item.title,
					remark: item.remark,
					createTime: item.createTime
				}
			})
		},
		newstypeChange(type){
			this.newstype = type.id
			this.getListByPage()
		},
	},
	mounted() {
		/* wowjs动画 */
		var wow = new WOW({
			boxClass: 'wow',
			animateClass: 'animated',
			offset: 0,
			mobile: true,
			live: true
		})
		wow.init();

		this.initPage()
	},
	computed: {

	},
}
</script>

<style scoped lang="scss">
	*{
		box-sizing: border-box;
	}
	ul,ol {
	    list-style: none
	}
	.slider_img {
		height: 600px;
		width: 100%;
	}
	/* 业务涵盖 */
	#Service{
	  margin-top: 50px;
	}
	.container{
		width: 1200px;
		margin:0px auto;
	}
	.Service-container{
	    padding: 30px 50px;
	}
	.Service-item{
	    margin-bottom: 50px;
	}
	.Service-item-wrapper{
	    cursor: pointer;
	    background: rgba(244,244,244,1);
	    overflow: hidden;
	    position: relative;
	}
	.Service-item-top{
	    width: 100%;
	    height: 120px;
	    padding: 30px;
	    text-align: center;
		h4{
			font-weight: normal;
			font-size: 24px;
			color: #000;
		}
	}
	.Service-item-top>i{
	    display: inline-block;
	    width: 25px;
	    height: 2px;
	    background: #28f;
	}
	.Service-item-top>p{
	    color: #b2b2b2;
	    opacity: 0;
	    transform: translateY(10px);
	    transition: all .5s ease;
	}
	.Service-item-img{
	    width: 100%;
	    overflow: hidden;
	}
	.Service-item-img img{
	    width: 100%;
	    transition: all 0.5s ease;
	}
	.Service-item-border{
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto;
	    z-index: 3;
	    width: 100%;
	    height: 100%;
	    transition: all 0.5s ease;
	    border: 1px solid #000;
	    opacity: 0;
	}
	.Service-item-wrapper:hover .Service-item-top > i{
	    opacity: 0;
	}
	.Service-item-wrapper:hover .Service-item-top > p{
	    opacity: 1;
	    transform: translateY(-10px);
	}
	.Service-item-wrapper:hover .Service-item-img > img{
	    transform: scale(1.1,1.1);
	}
	.Service-item-wrapper:hover > .Service-item-border{
	    opacity: 1;
	    width: 90%;
	    height: 90%;
	}

	// 公司简介
	.company{
		width: 1200px;
		margin: 20px auto 80px auto;
		// background-color: rgb(248, 248, 248);
		.company-text{
			padding: 30px 30px 0 0;

			h5{
				font-size: 30px;
				line-height: 30px;
				font-weight: normal;
				color:rgb(51, 51, 51);
				margin-top: 30px;
				span{
					font-size: 16px;
					color: #b2b2b2;
					margin-left: 10px;
				}
			}
			p{
				margin-top: 20px;
				color:rgb(51, 51, 51);
				font-size: 16px;
				line-height: 2;
			}
		}
	}

	//经典案例
	.case-box{
		background-image: url(../assets/img/company.jpg);
		background-size: cover;
	}
	.case-item {
	  width: 1250px;
	  height: 360px;
	  overflow: hidden;
	  margin: 0 auto;
	  margin-top: 30px;
	  display: flex;
	  flex-wrap: wrap;
	  justify-content: flex-start;
	  li {
	    width: 388px;
	    height: 250px;
	    list-style: none;
	    background-repeat: no-repeat;
	    background-size: cover;
	    background-position: center;
	    background-origin: content-box;
	    margin: 12px;
	    position: relative;
	    overflow: hidden;
		border: 2px solid #FFFFFF;
		border-radius: 5px;

	    &:hover {
	      .case-item-hover {
	        opacity: 1;
	        transition: all 0.4s ease-in-out;
	      }
	    }
	  }
	}
	//经典案例hover
	.case-item-hover {
	  width: 100%;
	  height: 100%;
	  position: absolute;
	  top: 0;
	  left: 0;
	  opacity: 0;
	  overflow: hidden;
	  background-color: rgba(225, 56, 52, 0.7);

	  .classname{
		  color: #FFFFFF;
		  text-align: center;
		  font-size: 16px;
		  margin-top: 25px;
	  }
	  .hover-title {
	    color: #fff;
	    font-size: 18px;
	    font-weight: 400;
	    margin-top: 5px;
		margin-bottom: 10px;
		text-align: center;
	  }
	  .bottom {
	    border-bottom: 1px solid #fff;
	    width: 60px;
	    margin: 0 auto;
	  }
	  .more {
	    width: 90px;
	    padding: 5px 5px;
	    position: absolute;
		bottom: 40px;
		left: 50%;
		margin-left: -45px;
	    border: 2px solid #fff;
		text-align: center;
	    span {
	      color: #fff;
	      font-size: 20px;
	    }
	  }
	}

	// 新闻资讯

	.content-nav-item {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        //border: 1px solid blue;
        .item-list {
			width: 31%;
			background: #fff;
			// height: 350px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border: 1px solid #f4f4f4;
			padding-top: 15px;
			box-shadow: 4px 5px 15px 2px#fff;
			transition: all 0.5s;
			margin-bottom: 20px;
          &:hover {
            border: 1px solid #fff;
            box-shadow: 4px 5px 15px 2px#ebebeb;
 			cursor: pointer;
			.item-list-more{
				span{
					color:#f00;
				}
			}
          }
          .item-img {
            width: 90%;
            height: 148px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 90%;
			font-size: 18px;
			margin: 14px 0 10px 0;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
          }

          &-content {
            width: 90%;
			/* padding: 0 14px; */
			line-height: 20px;
			font-size: 14px;
			color: gray;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			white-space: normal !important;
			word-wrap: break-word;
          }
          &-more {
            width: 90%;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-pack: start;
			-ms-flex-pack: start;
			justify-content: flex-start;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			line-height: 35px;
			margin-bottom: 20px;
            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #727272;
              padding: 0 5px;
            }
          }
        }
      }

	#NewsInformation {
		min-height: 500px;
    	background: #f7f7f7;
   		padding:40px 0 40px 0
	}
	.read_more{
    	margin: 20px 0 10px 0;
		a{
			color: #fff;
			background: linear-gradient(45deg, #409eff, #1e78ca);
			line-height: 46px;
			padding: 0 40px;
			display: inline-block;
			border-radius: 4px;
			text-decoration: none;
			&:hover{
				background: #1088ff;
			}
		}
	}
	.nav{
		margin: 30px 0;
	}
	.nav>a{
	    display: inline-block;
		text-decoration: none;
		width: 160px;
		height: 50px;
		line-height: 50px;
		color: #535353;
		margin-right: 10px;
		border: 1px solid #dedede;
		font-size: 20px;
		border-radius: 4px;

	}
	.nav>a.active{
	    color: #fff;
		border-color: #f7f7f7;
   		background: linear-gradient(45deg, #c32a2b, #e84248);
	}
	.nav>a:hover{
	    color: #ffffff;
	    border-color: #1e73be;
	    background: #1e73be;
	}
	.news-container{
	    overflow: hidden;
	    margin-bottom: 0px;
	}
	.news-container>li{
	    width: 55.6%;
	    height: 120px;
	    float: left;
	    color: #333;
	    text-align: right;
	    border-left: 1px solid transparent;
	    border-right: 1px solid transparent;
	}
	.news-container>li:hover{
	    color: #1e73be;
	    border: 1px solid #1e73be;
	    cursor: pointer;
	}
	.news-container>li:nth-of-type(2n){
	    float: right;
	    text-align: left;
	}
	.news-container>li>.content{
	    width: 60%;
	    float: left;
	    padding: 20px 0;
		h5{
			font-size: 18px;
			color: #333;
		}
		p{
			margin-top: 5px;
			color: #666;
		}
	}
	.news-container>li>.time{
	    width: 20%;
	    float: left;
	    padding: 15px 0;
	}
	.news-container>li>.time>p{
	    font-size: 30px;
	    margin: 5px 0;
	}
	.news-container>li>.circle{
	    width: 20%;
	    height: 100%;
	    float: left;
	    position: relative;
		.center-block {
		    display: block;
		    margin-right: auto;
		    margin-left: auto;
		}
	}
	.news-container>li>.circle>img{
	    position: absolute;
	    top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto;
	    width: 20px;
	    height: 20px;
	}
	.news-container>li>.circle>i{
	    display: block;
	    width: 1px;
	    height: 100%;
	    background: #707070;
	}
	.news-container>li:nth-of-type(2n)>.content{
	    float: right;
	}
	.news-container>li:nth-of-type(2n)>.time{
	    float: right;
	}
	.news-container>li:nth-of-type(2n)>.circle{
	    float: right;
	}
	.news-container>li:nth-of-type(1)>.circle>i{
	    height: 50%;
	    position: absolute;
	    top: 50%;
	    left: 50%;
	}
	.more{
	    font-size: 25px;
	    color: #707070;
	}
	.more>i{
	    cursor: pointer;
	}
</style>
